<template>
<!--  <keep-alive max="5">-->
<!--    <router-view>-->

<!--    </router-view>-->
<!--  </keep-alive>-->
<!--  <keep-alive max="10">-->

  <div id="app-root">
    <router-view v-slot="{ Component }" >
      <component :is="Component" />
    </router-view>
    <UpdateChecker />
  </div>
<!--  </keep-alive>-->

</template>

<script>
import UpdateChecker from '@/views/includes/UpdateChecker.vue'

// Never let the browser navigate to / open a file dropped outside a drop zone.
const blockFileDrop = (ev) => {
  if (ev.dataTransfer && Array.from(ev.dataTransfer.types || []).indexOf('Files') >= 0) ev.preventDefault()
}

export default {
  name: 'App',
  components: { UpdateChecker },
  mounted() {
    window.addEventListener('dragover', blockFileDrop)
    window.addEventListener('drop', blockFileDrop)
  },
  beforeUnmount() {
    window.removeEventListener('dragover', blockFileDrop)
    window.removeEventListener('drop', blockFileDrop)
  }
}</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>

